import config from '../services/config';

export default {
  dataFormat: {
    default: 'object',
    matches: 'array',
    betGroups: 'array',
  },
  dataShrink: !config.debug,
  language: {
    default: config.language,
  },
  params: {
    delivery_platform: config.delivery_platform,
    company_uuid: config.company_uuid,
  },
};
